module.exports = __webpack_public_path__ + "static/media/rydz7.536bee72.jpeg";